import React, { useEffect } from 'react'
import { useMappedState, useDispatch } from 'redux-react-hook';
import { DownloadInvoice, FetchInvoices } from "../../store/invoices/actions";
import { List, ListItem } from "material-ui";

const style = {
    height: 500,
    width: 400,
    margin: 20,
    textAlign: 'center',
    display: 'inline-block'
};

const mapState = state => ({
  invoices: state.invoices,
});

const Invoices = () => {
  const { invoices } = useMappedState(mapState);
  const dispatch = useDispatch();

  useEffect(() => getInvoices(), []);

  const getInvoices = () => {
      if(!invoices.length) dispatch(FetchInvoices())
  }

  const downloadInvoice = (id) => {
    dispatch(DownloadInvoice(id))
  }

  return (
    <div style={style}>
      <h1>Lista faktur</h1>
      <List>
        {invoices.map(el => (
          <ListItem primaryText={el.numer} key={el.id} onClick={() => downloadInvoice(el.id)}/>
        ))}
      </List>
    </div>
  )
}

export default Invoices


// WEBPACK FOOTER //
// ./src/components/Invoices/Invoices.js